import { BlobServiceClient } from "@azure/storage-blob";
import { EventEmitter } from "events"

export class AzureBlobUpload {
  constructor(blob) {
    this.blob = blob
    this.file = blob.file
    this.emitter = new EventEmitter()

    const { url, headers } = blob.directUploadData

    this.headers = headers

    // Parse the URL to get the container and blob name
    const urlParts = url.match(/^https:\/\/([^\.]+)\.blob\.core\.windows\.net\/([^\/]+)\/(.+)$/)
    if (!urlParts) {
      throw new Error("Invalid Azure Blob Storage URL")
    }

    const urlObj = new URL(url);
    const pathParts = urlObj.pathname.split('/');

    this.accountName = urlParts[1]
    this.containerName = urlParts[2]
    this.blobName = pathParts.slice(2).join('/');

    this.sasToken = urlObj.search;

    this.blobServiceClient = new BlobServiceClient(`https://${this.accountName}.blob.core.windows.net${this.sasToken}`)
  }

  async create(callback) {
    this.callback = callback

    try {
      const containerClient = this.blobServiceClient.getContainerClient(this.containerName)
      const blockBlobClient = containerClient.getBlockBlobClient(this.blobName)
      await blockBlobClient.uploadData(this.file, {
        blockSize: 10 * 1024 * 1024,
        maxSingleShotSize: 20 * 1024 * 1024, // chunk anything over 20mb
        concurrency: 3,
        blobHTTPHeaders: {
          blobContentType: this.headers['Content-Type'],
          blobContentMD5: Uint8Array.from(atob(this.headers['Content-MD5']), c => c.charCodeAt(0)),
          blobContentDisposition: this.headers['x-ms-blob-content-disposition'],
        },
        onProgress: (progress) => {
          this.emitter.emit('progress', {
            ...progress,
            totalBytes: this.file.size,
            pct: (progress.loadedBytes / this.file.size)
          })
        }
      })
      this.callback(null, "Upload successful")
    } catch (error) {
      this.requestDidError(error)
    }
  }

  requestDidError(error) {
    this.callback(`Error storing "${this.file.name}". ${error.message}`)
  }

  on(...args) {
    this.emitter.on(...args);
  }

  off(...args) {
    this.emitter.off(...args);
  }
}


